import React from 'react';
import { Box } from '@chakra-ui/react';
import TablaAgenda from './TablaAgenda';

const Agenda: React.FC = () => (
  <Box px={{ base: 2, md: 4 }} pt={79} pb={4}>
    <TablaAgenda />
  </Box>
);

export default Agenda;
